/* Site Insights collector (2026-10-15). Loaded by snippets/site-insights-tracker.liquid, which describes the
   page in #si-cfg's data attributes. Sends one small beacon when the page opens, then updates (time on the page,
   how far down it was scrolled, clicks, goals) to /apps/distributor/si-in → D1 (scripts/site-insights.js).
   - Never reads what anyone types: form boxes are labelled by kind only, and on private pages
     (data-pv="1": My Account, the distributor builders) no page text is read at all.
   - Off for browsers sending Global Privacy Control, automation (navigator.webdriver), bots, and inside frames.
   - Ids are random: si_v (this browser, localStorage), si_s (this visit: ends after 30 idle minutes).
   - A visit only counts on the dashboard once a person is in it (hum: scrolled, clicked, typed or the
     page stayed in view 5 s), so link scanners and prefetchers don't.
   - The top menu (2026-10-19): assets/nav-showroom.js says which panel / rail group / phone-menu level is on
     screen ('nsr:track'); each look that stays up 0.4 s (or gets a click) and every click in the menu is sent as
     a menu row (b.m) for the top menu heatmap. The menu's own names are read on every page (they're the same
     for everyone), never the page around it.
   Plain ES5 like theme.js. Test: node scripts/tests/test-site-insights.js */
(function () {
  var cfg = document.getElementById('si-cfg');
  if (!cfg || window.__SI_ON) return;
  window.__SI_ON = true;
  var C = {
    pk: cfg.getAttribute('data-pk') || '', pl: cfg.getAttribute('data-pl') || '', pt: cfg.getAttribute('data-pt') || '',
    nm: cfg.getAttribute('data-nm') || '', pv: cfg.getAttribute('data-pv') === '1', q: ''
  };
  if (!C.pk) return;
  if (C.pt === 'search') { try { C.q = new URLSearchParams(location.search).get('q') || ''; } catch (e) {} }
  var nav = navigator;
  try { if (window.top !== window.self) return; } catch (e) { return; }
  try { if (nav.globalPrivacyControl || nav.webdriver) return; } catch (e) {}
  if (/bot|crawl|spider|slurp|headless|lighthouse|pagespeed|gtmetrix|pingdom|preview|facebookexternalhit|prerender/i.test(nav.userAgent || '')) return;

  var EP = window.__SI_EP || '/apps/distributor/si-in';
  var IDLE = 30 * 60 * 1000;
  var ID_RE = /^[a-z0-9]{8,32}$/;
  var INTER = 'a,button,input,select,textarea,label,summary,option,[role="button"],[role="link"],[role="tab"],[role="menuitem"],[role="checkbox"],[role="switch"],[onclick],[data-modal],[contenteditable="true"],[contenteditable=""],[tabindex]:not([tabindex="-1"])';

  function rid() {
    var s = '';
    try { var a = new Uint8Array(12); window.crypto.getRandomValues(a); for (var i = 0; i < a.length; i++) s += (a[i] % 36).toString(36); }
    catch (e) { s = Math.random().toString(36).slice(2, 14); }
    return (s + Date.now().toString(36)).slice(0, 20);
  }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

  var vid = lsGet('si_v');
  if (!vid || !ID_RE.test(vid)) { vid = rid(); lsSet('si_v', vid); }
  var sid = '', entry = false, lastTouch = 0;
  function session() {
    var s = null, t = Date.now();
    try { s = JSON.parse(lsGet('si_s') || 'null'); } catch (e) { s = null; }
    entry = false;
    if (!s || !s.id || !ID_RE.test(s.id) || t - (s.t || 0) > IDLE) { s = { id: rid() }; entry = true; }
    s.t = t; lastTouch = t;
    lsSet('si_s', JSON.stringify(s));
    return s.id;
  }
  function touch() {
    var t = Date.now();
    if (t - lastTouch < 30000) return;
    lastTouch = t;
    lsSet('si_s', JSON.stringify({ id: sid, t: t }));
  }

  function device() {
    var coarse = false;
    try { coarse = window.matchMedia('(pointer: coarse)').matches; } catch (e) {}
    var small = Math.min(screen.width || 9999, screen.height || 9999) < 600;
    if (coarse && small) return 'p';
    if (coarse) return 't';
    return window.innerWidth < 600 ? 'p' : 'd';
  }
  var dev = device();

  // Only the referring site's address is sent, never the full link.
  function refInfo() {
    var r = '', h = '';
    try { h = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : ''; } catch (e) { h = ''; }
    if (h && h.replace(/^www\./, '') !== location.hostname.toLowerCase().replace(/^www\./, '')) r = 'https://' + h + '/';
    var u = { s: '', m: '', c: '' };
    try { var sp = new URLSearchParams(location.search); u = { s: sp.get('utm_source') || '', m: sp.get('utm_medium') || '', c: sp.get('utm_campaign') || '' }; } catch (e) {}
    return { ref: r, utm: u };
  }

  var pv, st, R, evQ, ckQ, mQ, mN, goalsSent, lastSig, lastBeat, timer = 0;
  function newView() {
    pv = rid(); sid = session();
    R = entry ? refInfo() : { ref: '', utm: {} };
    st = { ms: 0, dep: 0, clk: 0, rage: 0, dead: 0, hum: 0 };
    evQ = []; ckQ = []; mQ = []; mN = 0; goalsSent = {}; lastSig = ''; lastBeat = 0;
  }
  function viewFacts() {
    var search = C.pt === 'search';
    return {
      pk: C.pk, pl: C.pl, pt: C.pt, path: location.pathname.slice(0, 200), entry: entry ? 1 : 0,
      ref: R.ref, utm: R.utm, q: search ? String(C.q || '') : '', qz: search && document.getElementById('sr-empty') ? 1 : 0,
    };
  }

  var vis = document.visibilityState !== 'hidden', lastTick = Date.now();
  function tick() {
    var t = Date.now();
    if (vis) st.ms += Math.min(t - lastTick, 120000);
    lastTick = t;
    if (vis && st.ms >= 5000) human(true);
  }

  function post(body) {
    var s = JSON.stringify(body);
    try { if (nav.sendBeacon && nav.sendBeacon(EP, new Blob([s], { type: 'text/plain' }))) return; } catch (e) {}
    try { window.fetch(EP, { method: 'POST', body: s, keepalive: true, credentials: 'same-origin', headers: { 'Content-Type': 'text/plain' } }); } catch (e) {}
  }
  function flush(force) {
    if (timer) { clearTimeout(timer); timer = 0; }
    tick();
    var u = { ms: st.ms, dep: st.dep, clk: st.clk, rage: st.rage, dead: st.dead, hum: st.hum };
    var sig = [u.ms, u.dep, u.clk, u.rage, u.dead, u.hum].join(',');
    var t = Date.now();
    if (!force && !evQ.length && !ckQ.length && !mQ.length && (sig === lastSig || t - lastBeat < 10000) && t - lastBeat < 60000) return;
    var b = { pv: pv, vid: vid, sid: sid, pk: C.pk, dev: dev, n: viewFacts(), u: u };
    if (evQ.length) b.e = evQ.splice(0, 10);
    if (ckQ.length) b.c = ckQ.splice(0, 40);
    if (mQ.length) b.m = mQ.splice(0, 40);
    if (C.nm) b.nm = String(C.nm).slice(0, 80);
    lastSig = sig; lastBeat = t;
    post(b);
    if (ckQ.length || evQ.length || mQ.length) schedule(50);
  }
  function schedule(ms) { if (timer) clearTimeout(timer); timer = setTimeout(function () { timer = 0; flush(true); }, ms); }

  function human(quiet) {
    touch();
    if (st.hum) return;
    st.hum = 1;
    if (!quiet) schedule(400);
  }

  function depth() {
    var d = document.documentElement, b = document.body;
    var h = Math.max(d.scrollHeight || 0, b ? b.scrollHeight : 0);
    var y = (window.pageYOffset || d.scrollTop || 0) + window.innerHeight;
    var p = h > 0 ? Math.min(100, Math.round(y / h * 100)) : 100;
    if (p > st.dep) st.dep = p;
  }
  var raf = 0;
  function onScroll() {
    human();
    if (raf) return;
    var run = function () { raf = 0; depth(); };
    raf = window.requestAnimationFrame ? window.requestAnimationFrame(run) : setTimeout(run, 16);
  }

  // ── clicks ──
  function cls(el) {
    var c = typeof el.className === 'string' ? el.className : (el.getAttribute && el.getAttribute('class')) || '';
    c = String(c).trim().split(/\s+/)[0] || '';
    return /^[a-z_-][\w-]{0,40}$/i.test(c) && !/\d{3,}/.test(c) ? c : '';
  }
  function selector(el) {
    var parts = [], n = el, i = 0;
    while (n && n.nodeType === 1 && i < 6 && n !== document.body && n !== document.documentElement) {
      var tag = n.tagName.toLowerCase(), id = n.id;
      if (id && /^[a-z][\w-]{0,40}$/i.test(id) && !/\d{4,}/.test(id)) { parts.unshift(tag + '#' + id); break; }
      var c = cls(n), part = tag + (c ? '.' + c : ''), p = n.parentElement;
      if (p) {
        var same = 0, idx = 0;
        for (var k = 0; k < p.children.length; k++) { if (p.children[k].tagName === n.tagName) { same++; if (p.children[k] === n) idx = same; } }
        if (same > 1) part += ':nth-of-type(' + idx + ')';
      }
      parts.unshift(part); n = p; i++;
    }
    return parts.join('>').slice(0, 200);
  }
  function label(el) {
    var tag = el.tagName.toLowerCase();
    var typed = /^(input|textarea|select|option)$/.test(tag) || el.isContentEditable;
    var s = el.getAttribute('aria-label') || (tag === 'img' ? el.getAttribute('alt') || '' : '');
    if (typed) {
      if (tag === 'input' && /^(submit|button|reset)$/i.test(el.type || '')) s = s || el.value || '';
      if (!s) s = tag === 'select' || tag === 'option' ? 'Dropdown' : (tag === 'input' && /^(checkbox|radio)$/i.test(el.type || '')) ? 'Checkbox' : 'Text box';
    } else if (!s && !C.pv) {
      s = el.innerText || el.textContent || '';
    }
    s = String(s).replace(/\s+/g, ' ').trim();
    if (s.length > 40) s = s.slice(0, 39) + '…';
    return s || (tag + (cls(el) ? '.' + cls(el) : ''));
  }
  function clickRec(e, el, kind) {
    var r = el.getBoundingClientRect ? el.getBoundingClientRect() : { left: 0, top: 0, width: 0, height: 0 };
    var d = document.documentElement, b = document.body;
    // Enter or Space on a button "clicks" it with no pointer position: record the middle of the element.
    var kb = !e.detail && !e.clientX && !e.clientY, px = window.pageXOffset || 0, py = window.pageYOffset || 0;
    return {
      k: kind, s: selector(el), l: label(el),
      x: Math.round(kb ? r.left + px + r.width / 2 : (e.pageX || 0)), y: Math.round(kb ? r.top + py + r.height / 2 : (e.pageY || 0)),
      dw: d.scrollWidth, dh: Math.max(d.scrollHeight || 0, b ? b.scrollHeight : 0),
      ox: kb ? 0.5 : r.width ? (e.clientX - r.left) / r.width : null, oy: kb ? 0.5 : r.height ? (e.clientY - r.top) / r.height : null,
      vw: window.innerWidth,
    };
  }
  function pushClick(rec) { ckQ.push(rec); if (ckQ.length >= 20) flush(true); else if (!timer) schedule(5000); }
  // A dead click: something that looks clickable (a picture, a table cell, a heading, a pointer cursor)
  // where nothing happened for a second — no change on the page, no scroll, no new address, no text picked.
  function looksClickable(el) {
    if (/^(img|svg|path|use|th|td|h1|h2|h3|h4|h5|h6|picture)$/i.test(el.tagName)) return true;
    try { return window.getComputedStyle(el).cursor === 'pointer'; } catch (e) { return false; }
  }
  function watchDead(rec) {
    var changed = false, sy = window.pageYOffset, href = location.href, mo;
    try { mo = new MutationObserver(function () { changed = true; }); mo.observe(document.body, { childList: true, subtree: true, attributes: true, characterData: true }); }
    catch (e) { pushClick(rec); return; }
    setTimeout(function () {
      try { mo.disconnect(); } catch (e) {}
      var picked = ''; try { picked = String(window.getSelection() || ''); } catch (e) {}
      if (!changed && !picked && window.pageYOffset === sy && location.href === href) { rec.k = 'd'; st.dead++; }
      pushClick(rec);
    }, 1000);
  }
  function goal(k) { if (goalsSent[k]) return; goalsSent[k] = 1; evQ.push(k); schedule(1500); }
  function goalsFor(el) {
    if (!el.closest) return;
    var m = el.closest('[data-modal]');
    if (m) {
      var v = m.getAttribute('data-modal');
      if (v === 'quote') goal('rfq_open'); else if (v === 'vproof') goal('proof_open'); else if (v === 'sample') goal('sample_open');
    }
    if (el.closest('.pdp__action-btn--po, a[href*="/pages/build-order"]')) goal('po_click');
  }

  // ── the top menu (Showroom) ──
  // MS = the menu session on screen (opened → closed), MT = its tab (desktop) or phone-menu level, MV = the rail
  // group inside a desktop tab. Rows: k 'o' = a tab / level looked at, 'v' = a rail group looked at, 'c' = a click.
  var MS = null, MT = null, MV = null, mSeq = 0, LOOK = 400, MCAP = 120000;
  function mClip(s, n) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim().slice(0, n); }
  function mPush(r) { if (mN >= 200) return; mN++; mQ.push(r); if (!timer) schedule(5000); }
  function mEndSub(t) {
    if (!MV || !MT) { MV = null; return; }
    var ms = t - MV.t0;
    if (ms >= LOOK || MV.h) mPush({ k: 'v', m: MS.m, o: MS.o, t: MT.tab, tl: MT.tl, s: MV.sub, l: MV.sl, ms: Math.min(ms, MCAP), h: MV.h });
    MV = null;
  }
  function mEndTab(t) {
    if (!MT) return;
    mEndSub(t);
    var ms = t - MT.t0;
    // f = the first tab of this menu session that counted (a skimmed one before it doesn't)
    if (ms >= LOOK || MT.h) { mPush({ k: 'o', m: MS.m, o: MS.o, t: MT.tab, tl: MT.tl, ms: Math.min(ms, MCAP), h: MT.h, v: MT.via, f: MS.n ? 0 : 1 }); MS.n++; }
    MT = null;
  }
  function mEnd(t) { mEndTab(t); MS = null; }
  function onMenu(d) {
    if (!d || typeof d !== 'object') return;
    var t = Date.now();
    if (d.ev === 'close') { mEnd(t); return; }
    if (d.ev !== 'view' || !d.tab) return;
    var m = d.m === 'p' ? 'p' : 'd', tab = mClip(d.tab, 80), sub = mClip(d.sub, 80);
    if (MS && MS.m !== m) mEnd(t);
    if (!MS) MS = { m: m, o: ++mSeq, n: 0 };
    if (!MT || MT.tab !== tab) {
      mEndTab(t);
      MT = { tab: tab, tl: mClip(d.tl, 80), t0: t, h: 0, via: /^(hover|click|tap|key)$/.test(d.via || '') ? d.via : '' };
    }
    if (m === 'd' && (!MV || MV.sub !== sub)) { mEndSub(t); if (sub) MV = { sub: sub, sl: mClip(d.sl, 80), t0: t, h: 0 }; }
  }
  // what a click in the menu was on (the heatmap finds the same kind of element again)
  function mZone(a) {
    if (a.hasAttribute('data-nsr-tab')) return 'tab';
    if (a.hasAttribute('data-nsm-back')) return 'back';
    if (a.hasAttribute('data-nsm-go')) return 'go';
    var c = a.classList;
    if (c.contains('nsr-r')) return 'rail';
    if (c.contains('nsr-pko')) return 'pick';
    if (c.contains('nsr-tile--all')) return 'all';
    if (c.contains('nsr-tile') || c.contains('nsr-tile-a') || c.contains('nsm-t')) return 'tile';
    if (c.contains('nsr-fc')) return 'spot';
    if (c.contains('nsr-pc') || c.contains('nsr-pr')) return 'feat';
    if (c.contains('nsr-co')) return 'call';
    if (c.contains('nsr-btn') || c.contains('nsm-l2a')) return 'shop';
    if (c.contains('nsm-qa')) return 'quick';
    if (c.contains('nsm-fl')) return 'foot';
    if (c.contains('nsm-gh')) return 'group';
    if (c.contains('nsm-li') || c.contains('nsm-cc')) return 'list';
    return 'other';
  }
  var ZSEL = { tile: '.nsr-tile, .nsm-t', feat: '.nsr-pc, .nsr-pr', pick: '.nsr-pko', rail: '.nsr-r', quick: '.nsm-qa', foot: '.nsm-fl', list: '.nsm-li, .nsm-cc', go: '[data-nsm-go]' };
  function mLabel(a, z) {
    var q = function (s) { var e = a.querySelector(s); return e ? e.getAttribute('data-full') || e.getAttribute('title') || e.textContent : ''; };
    var s = '';
    if (z === 'tile') s = q('.nsr-tn') || q('.nsm-tn');
    else if (z === 'rail') s = q('.nsr-rn');
    else if (z === 'spot') s = q('.nsr-fc-t');
    else if (z === 'feat') s = q('.nsr-pc-t') || q('.nsr-pr-t');
    else if (z === 'call') s = q('.nsr-co-t');
    else if (z === 'pick') s = a.firstChild && a.firstChild.nodeType === 3 ? a.firstChild.nodeValue : '';
    else if (z === 'all') s = 'View all';
    else s = q('.nsm-ccn') || q('.nsm-ln') || q('.nsm-qat');
    return mClip(s || a.getAttribute('aria-label') || a.textContent || '', 60);
  }
  function menuClick(e, el) {
    var a = el.closest('a, button');
    var root = a && a.closest('[data-nsr], [data-nsm]');
    if (!root) return;
    var phoneSide = root.hasAttribute('data-nsm'), z = mZone(a), tab = '', tl = '', sub = '';
    if (z === 'tab') { tab = a.getAttribute('data-nsr-tab') || ''; tl = mClip(a.textContent, 80); }
    else if (phoneSide) { var lv = a.closest('.nsm-level'); tab = lv ? lv.getAttribute('data-level') || '' : ''; tl = MT && MT.tab === tab ? MT.tl : ''; }
    else if (MT && MS && MS.m === 'd') { tab = MT.tab; tl = MT.tl; sub = MV ? MV.sub : ''; }
    if (!tab) return;
    var href = a.tagName === 'A' ? a.getAttribute('href') || '' : '';
    var u = z === 'rail' ? a.getAttribute('data-sub') || '' : z === 'go' ? 'go:' + a.getAttribute('data-nsm-go') : z === 'back' ? 'back' :
      /^mailto:/i.test(href) ? 'mailto' : href && href !== '#' ? (a.pathname || href) : '';
    var leaves = href && href !== '#' && !/^(rail|go|back)$/.test(z);
    if (leaves && MT && MT.tab === tab) { MT.h = 1; if (MV && z !== 'tab') MV.h = 1; }
    var r = a.getBoundingClientRect(), kb = !e.detail && !e.clientX && !e.clientY;
    var scope = a.closest('.nsr-panel, .nsm-level'), i = 0;
    if (scope && ZSEL[z]) { var all = scope.querySelectorAll(ZSEL[z]); for (var k = 0; k < all.length; k++) if (all[k] === a) { i = k; break; } }
    mPush({ k: 'c', m: phoneSide ? 'p' : 'd', o: MS ? MS.o : 0, t: mClip(tab, 80), tl: tl, s: sub, z: z, u: mClip(u, 200), l: mLabel(a, z), i: i,
      ox: kb || !r.width ? 0.5 : (e.clientX - r.left) / r.width, oy: kb || !r.height ? 0.5 : (e.clientY - r.top) / r.height });
  }

  var recent = [], burstUntil = 0;
  function onClick(e) {
    var el = e.target;
    if (el && el.nodeType !== 1) el = el.parentElement;
    if (!el || !el.tagName) return;
    human();
    goalsFor(el);
    if (el.closest) { try { menuClick(e, el); } catch (er) {} }
    if (st.clk >= 300) return;
    st.clk++;
    var t = Date.now(), x = e.pageX || 0, y = e.pageY || 0, near = 0, rage = false;
    var keep = [];
    for (var i = 0; i < recent.length; i++) if (t - recent[i].t < 1000) keep.push(recent[i]);
    keep.push({ t: t, x: x, y: y }); recent = keep;
    for (var j = 0; j < recent.length; j++) if (Math.abs(recent[j].x - x) < 30 && Math.abs(recent[j].y - y) < 30) near++;
    if (near >= 3) { if (t > burstUntil) { rage = true; st.rage++; } burstUntil = t + 1000; }
    var inter = el.closest ? el.closest(INTER) : null;
    var rec = clickRec(e, inter || el, rage ? 'r' : 'n');
    if (rage || inter || !looksClickable(el)) pushClick(rec);
    else watchDead(rec);
  }

  // ── goals the page announces itself ──
  function watchGoals() {
    var pairs = [['quote-success', 'rfq_sent'], ['vproof-success', 'proof_sent'], ['sample-success', 'sample_sent']];
    if (window.MutationObserver) {
      pairs.forEach(function (p) {
        var el = document.getElementById(p[0]);
        if (!el) return;
        new MutationObserver(function () { if (!el.hidden) goal(p[1]); }).observe(el, { attributes: true, attributeFilter: ['hidden'] });
      });
    }
    var grid = document.querySelector('.pricing-grid');
    if (grid && window.IntersectionObserver) {
      var io = new IntersectionObserver(function (en) {
        for (var i = 0; i < en.length; i++) if (en[i].isIntersecting) { goal('grid_seen'); io.disconnect(); break; }
      }, { threshold: 0.5 });
      io.observe(grid);
    }
  }

  newView();
  depth();
  flush(true);
  watchGoals();
  ['pointerdown', 'keydown', 'touchstart', 'mousemove'].forEach(function (n) { window.addEventListener(n, function () { human(); }, { passive: true, capture: true }); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('click', onClick, true);
  document.addEventListener('nsr:track', function (e) { onMenu(e.detail); });
  if (window.NSR && window.NSR.now) onMenu(window.NSR.now);
  document.addEventListener('visibilitychange', function () {
    tick();
    vis = document.visibilityState !== 'hidden';
    lastTick = Date.now();
    if (!vis) { mEnd(Date.now()); flush(true); }
  });
  window.addEventListener('pagehide', function () { mEnd(Date.now()); flush(false); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { MS = MT = MV = null; newView(); depth(); flush(true); } });
  setTimeout(function () { depth(); tick(); }, 2000);
  setInterval(function () { if (vis) flush(false); }, 15000);
})();
